import Layout from '@/layouts/Layout'

const logs = {
  path: '/logCenter',
  component: Layout,
  name: 'logCenter',
  meta: {
    title: '日志中心',
    icon: 'logCenter',
  },
  children: [
    {
      path: '/logCenter/workLog/list',
      name: 'workLog',
      component: () => import('@/pages/others/logs/workLog/list'),
      meta: { title: '日志', logEvent: '' },
    },
    {
      path: '/logCenter/loginLog/list',
      name: 'loginLog',
      component: () => import('@/pages/others/logs/loginLog'),
      meta: { title: '登录日志', logEvent: '' },
    },
    {
      path: '/logCenter/withholdExecLog/list',
      name: 'withhold_exec_log',
      component: () => import('@/pages/others/logs/withholdExecLog/list/index.vue'),
      meta: { title: '支付日志', logEvent: '', KeepAlive: false },
    },
    {
      path: '/logCenter/importCarInfoLog/list',
      name: 'vehicleInfoImportHistory',
      component: () => import('@/pages/others/logs/importCarInfoLog/list'),
      meta: { title: '车辆信息导入历史', logEvent: '' },
    },
    {
      path: '/logCenter/importInStockLog/list',
      name: 'vehicleConfirmImportHistory',
      component: () => import('@/pages/others/logs/importInStockLog/list'),
      meta: { title: '确认到库导入历史', logEvent: '' },
    },
    {
      path: '/logCenter/importLisencePictureLog/list',
      name: 'vehicleImageImportHistory',
      component: () => import('@/pages/others/logs/importLisencePictureLog/list'),
      meta: { title: '证照图片导入历史', logEvent: '' },
    },
    {
      path: '/logCenter/importCustomerLisenceLog/list',
      name: 'customerImageImportHistory',
      component: () => import('@/pages/others/logs/importCustomerLisenceLog/list'),
      meta: { title: '客户证照导入历史', logEvent: '' },
    },
    {
      path: '/logCenter/importPolicyInfoLog/list',
      name: 'policyImportHistory',
      component: () => import('@/pages/others/logs/importPolicyInfoLog/list'),
      meta: { title: '保单信息导入历史', logEvent: '' },
    },
    {
      path: '/logCenter/importPolicyFileLog/list',
      name: 'policyFileImportHistory',
      component: () => import('@/pages/others/logs/importPolicyFileLog/list'),
      meta: { title: '保单附件导入历史', logEvent: '' },
    },
    {
      path: '/logCenter/importMaintenanceInfoLog/list',
      name: 'maintenanceImportHistory',
      component: () => import('@/pages/others/logs/importMaintenanceInfoLog/list'),
      meta: { title: '维保信息导入历史', logEvent: '' },
    },
    {
      path: '/logCenter/importAccidentLog/list',
      name: 'accidentInfoImport',
      component: () => import('@/pages/others/logs/importAccidentLog/list'),
      meta: { title: '事故信息导入历史', logEvent: '' },
    },
    {
      path: '/logCenter/importViolationRecordLog/list',
      name: 'violationImportHistory',
      component: () => import('@/pages/others/logs/importViolationRecordLog/list'),
      meta: { title: '违章记录导入历史', logEvent: '' },
    },
    /** 20240101 线下批量收款 线下批量付款导入历史 */
    {
      path: '/logCenter/receivable/list',
      name: 'receivableImportHistory',
      component: () => import('@/pages/others/logs/receivableLog/list'),
      meta: { title: '线下批量收款导入历史', logEvent: '' },
    },
    {
      path: '/logCenter/payment/list',
      name: 'paymentImportHistory',
      component: () => import('@/pages/others/logs/paymentLog/list'),
      meta: { title: '线下批量付款导入历史', logEvent: '' },
    },
    {
      path: '/logCenter/salesClue/list',
      name: 'salesClueImportHistory',
      component: () => import('@/pages/others/logs/salesClueLog'),
      meta: { title: '销售线索导入历史', logEvent: '' },
    },
    {
      path: '/logCenter/batchImportOrder/list',
      name: 'batchImportOrderHistory',
      component: () => import('@/pages/others/logs/importOrderLog/list'),
      meta: { title: '批量导入订单导入历史', logEvent: '' },
    },
  ],
}
export default logs
